import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, Users } from "lucide-react";
import { toast } from "sonner";

export default function MesasAdmin() {
  const [mesas, setMesas] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ nombre: "", capacidad: 4 });
  const load = () => api.get("/mesas", { params: { only_active: false } }).then((r) => setMesas(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!form.nombre) return toast.error("Nombre requerido");
    try { await api.post("/mesas", { ...form, capacidad: parseInt(form.capacidad) || 4 }); toast.success("Mesa creada"); setOpen(false); setForm({ nombre: "", capacidad: 4 }); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const toggleActive = async (m) => {
    if (m.active) await api.delete(`/mesas/${m.id}`);
    else await api.patch(`/mesas/${m.id}`, { active: true });
    load();
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center flex-wrap gap-2">
        <div><h2 className="text-3xl font-black tracking-tight">Mesas</h2><p className="text-sm text-muted-foreground mt-1">Configura las mesas de tu sucursal.</p></div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="new-mesa-btn"><Plus className="h-4 w-4 mr-1" />Nueva mesa</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nueva mesa</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Nombre *</Label><Input value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} placeholder="Ej. Mesa 1, Terraza A…" data-testid="mesa-nombre-input" /></div>
              <div><Label>Capacidad</Label><Input type="number" value={form.capacidad} onChange={(e) => setForm({ ...form, capacidad: e.target.value })} /></div>
            </div>
            <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button><Button onClick={save}>Guardar</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {mesas.map((m) => (
          <Card key={m.id} className={m.active ? "" : "opacity-50"} data-testid={`mesa-card-${m.id}`}>
            <CardContent className="p-5">
              <div className="text-2xl font-black">{m.nombre}</div>
              <div className="flex items-center gap-1 mt-2 text-sm text-muted-foreground"><Users className="h-4 w-4" /> {m.capacidad} personas</div>
              <Button size="sm" variant={m.active ? "outline" : "default"} className="mt-3 w-full" onClick={() => toggleActive(m)}>
                {m.active ? "Desactivar" : "Activar"}
              </Button>
            </CardContent>
          </Card>
        ))}
        {mesas.length === 0 && <div className="col-span-full text-center text-muted-foreground py-8">Aún no hay mesas.</div>}
      </div>
    </div>
  );
}
